@if (loading()) {
	<nz-spin nzSimple nzSize="large"></nz-spin>
}

@if (activity() && !loading()) {
	<div [ngClass]="{ selected: selected() }">
		<div class="image-wrapper fade-in">
			@if (activity()?.active_text?.image_uri) {
				<img class="icon" [src]="activity()?.active_text?.image_uri" />
			}
		</div>
		@if (completed()) {
			<div class="completed-check">
				<img src="assets/img/completed_check.svg" />
			</div>
		}
		@if (activity()?.active_text) {
			<div class="activity-name fade-in">
				<ng-content></ng-content>
				{{ activity()?.active_text!.name }}
			</div>
		}
	</div>
}
